import { useState, useCallback } from "react";
import { storeConfig } from "../config/store.config";

// Local-only promo codes (Phase 1). Configure in store.config.js.
const usePromo = (subtotal) => {
  const [promoInput, setPromoInput] = useState("");
  const [appliedPromo, setAppliedPromo] = useState(null);
  const [promoError, setPromoError] = useState("");

  const applyPromo = useCallback(() => {
    const code = promoInput.trim().toUpperCase();
    if (!code) return;
    const found = storeConfig.promoCodes[code];
    if (!found) {
      setPromoError("Invalid promo code");
      setAppliedPromo(null);
      return;
    }
    setPromoError("");
    setAppliedPromo(code);
  }, [promoInput]);

  const removePromo = useCallback(() => {
    setAppliedPromo(null);
    setPromoInput("");
    setPromoError("");
  }, []);

  let discount = 0;
  if (appliedPromo) {
    const rule = storeConfig.promoCodes[appliedPromo];
    discount =
      rule.type === "percent"
        ? Math.round((subtotal * rule.value) / 100)
        : Math.min(rule.value, subtotal);
  }
  const total = Math.max(0, subtotal - discount);

  return {
    promoInput,
    setPromoInput,
    appliedPromo,
    promoError,
    applyPromo,
    removePromo,
    discount,
    total,
  };
};

export default usePromo;
